import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ParcDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-parc-multi',
  templateUrl: './parc-multi.component.html',
  styleUrls: ['./parc-multi.component.css']
})
export class ParcMultiComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.parcs$) parcs$: Observable<ParcDto[]>;

  private _parcIds: number[] = null;
  Parcs: ParcDto[] = [];

  @Input()
  get parcIds() {
    return this._parcIds;
  }
  set parcIds(val) {
    this._parcIds = val;
    this.getParcsInComponent();
  }

  @Input() titleAll: string;

  ParcsInComponent: string;

  p: Subscription;

  constructor(private translate: TranslateService) { }

  ngOnInit() {
    this.p = this.parcs$.subscribe(res => {
      if (res != null) {
        this.Parcs = res;
        this.getParcsInComponent();
      }
    });
  }

  getParcsInComponent() {
    let parcs = this.Parcs.filter(p => this._parcIds.includes(p.Id));

    if(parcs.length > 0) {
      if(parcs.length == this.Parcs.length) {
        this.ParcsInComponent = this.titleAll;
      }
      else if(parcs.length > 3) {
        this.ParcsInComponent = this.translate.instant("Parcs.List.SelectedParks").replace('#', parcs.length);
      } else {
        this.ParcsInComponent = parcs.map(p => p.Identifiant).join(", ");
      }
    } else {
      this.ParcsInComponent = this.translate.instant("Parcs.List.Aucun");
    }
  }

  ngOnDestroy() {
    this.p?.unsubscribe();
  }
}
